const schema = () => ({
  type: 'object',
  required: [],
  properties: {
    title: {
      type: 'string',
      title: 'عنوان',
    },
    shop_id: {
      type: 'string',
      title: 'فروشگاه',
    },
  },
});

export default schema;
